export const EDIT_EVALUATION_INFO = 'EDIT_EVALUATION_INFO';
export const EDIT_EVALUATION_QUESTION = 'EDIT_EVALUATION_QUESTION';

// steps of evaluation scheme
export const INITIAL_EVALUATION = 'INITIAL_EVALUATION';
export const START_EVALUATION = 'START_EVALUATION';
export const SIGNUP_EVALUATION = 'SIGNUP_EVALUATION';
export const SIGNIN_EVALUATION = 'SIGNIN_EVALUATION';
export const COMPLETED_EVALUATION = 'COMPLETED_EVALUATION';
export const PEER_SUBMITTED = 'PEER_SUBMITTED';
export const MAX_PEERS_REACHED = 'MAX_PEERS_REACHED';

// change state
export const CHANGE_EVALUATION_STATE = 'CHANGE_EVALUATION_STATE';

// complete evaluation
export const ADD_EVALUATION = 'ADD_EVALUATION';
export const ADD_EVALUATION_SUCCESS = 'ADD_EVALUATION_SUCCESS';
export const ADD_EVALUATION_FAILED = 'ADD_EVALUATION_FAILED';


// update author
export const EDIT_EVALUATION_AUTHOR = 'EDIT_EVALUATION_AUTHOR';
export const EDIT_EVALUATION_AUTHOR_SUCCESS = 'EDIT_EVALUATION_AUTHOR_SUCCESS';
export const EDIT_EVALUATION_AUTHOR_FAILED = 'EDIT_EVALUATION_AUTHOR_FAILED';

// update peer
export const EDIT_PEER_RESPONSE = 'EDIT_PEER_RESPONSE';
export const EDIT_PEER_RESPONSE_SUCCESS = 'EDIT_PEER_RESPONSE_SUCCESS';
export const EDIT_PEER_RESPONSE_FAILED = 'EDIT_PEER_RESPONSE_FAILED';



// WEBPACK FOOTER //
// ./src/modules/evaluation/constants.js